import { isWithin } from "./time";
import moment from "moment";

export const getWelcomeStatus = (welcome) => {
  if (isWithin(welcome?.time)) {
    return "ongoing";
  }
  return moment().isAfter(welcome?.time?.end) ? "expired" : "pending";
};

export const formatProductWithAvailableQty = (product, welcomes = []) => {
  if (!product || !product.id || !product.qty) {
    throw new Error("Invalid product object provided");
  }

  // Set default value for Welcome if it is undefined or 0
  const welcomeQty = product.qty.welcome || 0;

  // Flatten `products` from each welcome and filter by the matching `product.id`
  const totalWelcomeQty = welcomes.reduce((acc, welcome) => {
    // Accessing the products inside welcome.packs and processing each pack
    const matchingItems = welcome?.packs?.reduce((acc, pack) => {
      // Filter matching items in the current pack
      const packItems = pack.products.filter((item) => item.id === product.id);
      // Multiply item.qtyPerCollection by pack.qty for each matching item in the pack
      return acc.concat(packItems.map((item) => item.qtyPerCollection * pack.qty)); // Multiply by pack.qty here
    }, []) || [];

    // Sum the total quantities for the matching items
    const totalQtyForProduct = matchingItems.reduce((sum, qty) => sum + qty, 0);
    return acc + totalQtyForProduct;
  }, 0);

  // Calculate available quantity
  const availableQty = welcomeQty - totalWelcomeQty;

  return {
    ...product,
    qty: {
      ...product.qty,
      available: Math.max(availableQty, 0), // Ensure available qty is non-negative
    },
  };
};


